
import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Process() {
  const headingAnim = useScrollAnimation({ threshold: 0.2 });
  const stepsAnim = useStaggerAnimation(3, { threshold: 0.1 });

  const steps = [
    {
      number: '01',
      title: 'Strategy + Structure',
      description: 'We map out your goals, audience, and site structure to build a clear plan.',
      icon: 'ri-lightbulb-line',
    },
    {
      number: '02',
      title: 'Design + Build',
      description: 'Clean design, fast development, and mobile optimization — all in weeks.',
      icon: 'ri-code-s-slash-line',
    },
    {
      number: '03',
      title: 'Launch + Maintain',
      description: 'Go live with confidence. Ongoing support and updates are always included.',
      icon: 'ri-rocket-line',
    },
  ];

  return (
    <section className="py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div
          ref={headingAnim.ref}
          className="text-center mb-20"
          style={{
            opacity: headingAnim.isVisible ? 1 : 0,
            transform: headingAnim.isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1)',
          }}
        >
          <span className="font-inter font-semibold text-xs tracking-widest uppercase text-primary/60 mb-3 block">How It Works</span>
          <h2 className="font-sora font-bold text-4xl lg:text-[44px] text-charcoal leading-tight">
            Simple, clear process
          </h2>
        </div>

        <div ref={stepsAnim.ref} className="grid grid-cols-1 lg:grid-cols-3 gap-8 relative">
          <div
            className="hidden lg:block absolute top-16 left-[20%] right-[20%] h-px bg-gray-200"
            style={{
              transform: stepsAnim.isVisible ? 'scaleX(1)' : 'scaleX(0)',
              transition: 'transform 1s cubic-bezier(0.16, 1, 0.3, 1) 0.3s',
            }}
          ></div>
          
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative flex flex-col items-center text-center"
              style={{
                opacity: stepsAnim.isVisible ? 1 : 0,
                transform: stepsAnim.isVisible ? 'translateY(0) scale(1)' : 'translateY(40px) scale(0.92)',
                transition: `opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1) ${index * 0.18}s, transform 0.7s cubic-bezier(0.16, 1, 0.3, 1) ${index * 0.18}s`,
              }}
            >
              <div className="w-32 h-32 rounded-full bg-white border-2 border-gray-200 flex flex-col items-center justify-center mb-8 relative z-10 shadow-sm">
                <div className="w-8 h-8 flex items-center justify-center mb-1">
                  <i className={`${step.icon} text-2xl text-primary`}></i>
                </div>
                <span className="font-sora font-bold text-xl text-charcoal">
                  {step.number}
                </span>
              </div>
              <h3 className="font-sora font-semibold text-lg text-charcoal mb-3">
                {step.title}
              </h3>
              <p className="font-inter text-sm text-gray-500 leading-relaxed max-w-[260px]">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
